// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/assets/v1/color_preset.proto (package protos.vision.assets.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/assets/v1/color_preset.proto.
 */
export const file_vision_assets_v1_color_preset: GenFile = /*@__PURE__*/
  fileDesc("CiN2aXNpb24vYXNzZXRzL3YxL2NvbG9yX3ByZXNldC5wcm90bxIXcHJvdG9zLnZpc2lvbi5hc3NldHMudjEiqgEKC0NvbG9yUHJlc2V0EhEKCXByZXNldF9pZBgBIAEoCRIMCgRuYW1lGAIgASgJEhQKDG9yaWdpbmFsX3VybBgDIAEoCRIVCg10aHVtYm5haWxfdXJsGAQgASgJEh0KFWNvdW50c190b3dhcmRfc3RvcmFnZRgFIAEoCBIuCgpjcmVhdGVkX2F0GAYgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcGIGcHJvdG8z", [file_google_protobuf_timestamp]);

/**
 * @generated from message protos.vision.assets.v1.ColorPreset
 */
export type ColorPreset = Message<"protos.vision.assets.v1.ColorPreset"> & {
  /**
   * @generated from field: string preset_id = 1;
   */
  presetId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string original_url = 3;
   */
  originalUrl: string;

  /**
   * @generated from field: string thumbnail_url = 4;
   */
  thumbnailUrl: string;

  /**
   * @generated from field: bool counts_toward_storage = 5;
   */
  countsTowardStorage: boolean;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */
  createdAt?: Timestamp | undefined;
};

/**
 * Describes the message protos.vision.assets.v1.ColorPreset.
 * Use `create(ColorPresetSchema)` to create a new message.
 */
export const ColorPresetSchema: GenMessage<ColorPreset> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_color_preset, 0);

